import keyBy from 'lodash/keyBy';

import {cohortsClient} from 'common/report/queries/app-api/cohorts-client';
import {
  SerializedCohort,
  SerializedInlineCohort,
} from 'common/query-builder/cohorts-query-builder/models/types/serialized-cohort-types';

import {Store} from './store';

export interface CohortsMap {
  [cohortId: string]: SerializedCohort | SerializedInlineCohort;
}

export type CohortStore = Store<CohortsMap, Array<SerializedCohort | SerializedInlineCohort>>;

export const cohortsStore: CohortStore = new Store({
  apiClient: cohortsClient,
  defaultValue: {},
  name: `cohorts`,
  transform: {
    index: (cohorts) => keyBy(cohorts, `id`),
    update: (updatedCohort) => ({k: updatedCohort.id, v: updatedCohort}),
  },
});
